import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { QueryClientProvider } from "@tanstack/react-query";
import App from "./App.tsx";
import "./index.css";
import { queryClient } from "@/lib/react-query";
import {
  initAppInsights,
  restoreAuthenticatedUserContextFromStorage,
} from "@/telemetry/appInsights";
import { library, config } from "@fortawesome/fontawesome-svg-core";
import "@fortawesome/fontawesome-svg-core/styles.css";
import { faWallet, faShoppingCart } from "@fortawesome/free-solid-svg-icons";
import {
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcPaypal,
} from "@fortawesome/free-brands-svg-icons";

// Prevent Font Awesome from auto-adding CSS
config.autoAddCss = false;

// Add icons to the library
library.add(
  faWallet,
  faShoppingCart,
  faCcVisa,
  faCcMastercard,
  faCcAmex,
  faCcPaypal
);

initAppInsights();
restoreAuthenticatedUserContextFromStorage();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
